@if (banner) {
  <div class="disruption-container" @fadeIn>
    <div class="disruption-banner" [ngClass]="banner.bannerType">
      @switch (banner.bannerType) {
        @case ("success") {
          <app-svg-icon
            icon="checked-circle"
            size="medium"
            stroke="dark-green"
            fill="transparent"
          ></app-svg-icon>
        }
        @case ("warning") {
          <app-svg-icon
            icon="exclamation-triangle"
            size="medium"
            stroke="variants-orange-orange-900"
            fill="transparent"
          ></app-svg-icon>
        }
        @case ("error") {
          <app-svg-icon
            icon="exclamation-circle"
            size="medium"
            stroke="semantic-warning-red"
            fill="transparent"
          ></app-svg-icon>
        }
        @case ("info") {
          <app-svg-icon
            icon="info-circle"
            size="medium"
            stroke="voyage-blue"
            fill="transparent"
          ></app-svg-icon>
        }
        @case ("default") {
          <app-svg-icon
            icon="checked-circle"
            size="medium"
            stroke="transparent"
            fill="transparent"
          ></app-svg-icon>
        }
        @default {
          <app-svg-icon
            icon="checked-circle"
            size="medium"
            stroke="transparent"
            fill="transparent"
          ></app-svg-icon>
        }
      }
      <div class="disruption-banner__text-box">
        @if (banner.name) {
          <p class="disruption-banner__title">
            {{ banner.name }}
          </p>
        }
        @if (banner.message) {
          <div
            class="disruption-banner__desc"
            [innerHtml]="banner.message | safeHtml: SanitizerValueType.HTML"
          ></div>
        }
      </div>
      <button
        class="disruption-banner__close"
        [attr.data-qa]="'close-disruption-banner-' + banner.externalId"
        (click)="removeNotification(banner.externalId)"
      >
        <app-svg-icon
          icon="close-icon"
          size="small"
          [width]="10"
          [height]="10"
        ></app-svg-icon>
      </button>
    </div>
  </div>
}
